import {Modal} from 'antd';
import cn from 'classnames';
import React, {FC} from 'react';

import {TEditableColumn, EditableTable} from 'components/editable-table';
import {TableAction} from 'components/table/action';
import {IMetaActionInfo} from 'entities/metadata';
import {TEntity} from 'modules/data';
import {TModalComponentInterface} from 'store/slices/modals-slice';

import './editable-table-modal.less';

interface IEditableModalProps extends TModalComponentInterface {
    entityName: string;
    disabledPagination?: boolean;
    handleEdit: (row: TEntity, args?: any) => void;
    columns?: TEditableColumn[];
    onClose: () => void;
    onCancel?: () => void;
    modalTitle?: string;
    rowKey?: string;
    actions?: IMetaActionInfo[];
    data?: any;
    width?: number | string;
}

export const EditableTableModal: FC<IEditableModalProps> = ({
    entityName,
    onClose,
    handleEdit,
    columns,
    modalTitle,
    rowKey,
    data,
    actions,
    disabledPagination,
    width,
    onCancel,
}: IEditableModalProps) => (
    <Modal
        className={cn('editable-table-modal')}
        title={modalTitle}
        visible
        width={width || '95vw'}
        onCancel={onCancel}
        maskClosable={false}
        footer={null}
    >
        {columns && (
            <EditableTable
                disabledPagination={disabledPagination}
                handleSave={handleEdit}
                columns={columns}
                dataSource={data}
                rowKey={rowKey}
            />
        )}

        <div className="editable-container__actions">
            {actions?.map(action => (
                <TableAction
                    onClose={onClose}
                    meta={action}
                    key={action.actionTitle}
                    entityName={entityName}
                />
            ))}
        </div>
    </Modal>
);
